import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const StyledBoxWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['overridePadding'].includes(prop as string),
})(({  overridePadding, theme }) => ({
  padding: overridePadding || 24,
  borderRadius: 12,
  position: 'relative',
  backgroundColor: theme.palette.customWhite.main,
  border: `2px solid ${theme.palette.customBackground.disabled}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export default StyledBoxWrapper;
